const translations = {
    boundaries: 'Boundaries',
    boundariesPlaceholder: 'Add boundaries'
};

export default translations;
